import React from "react";
import { Background } from "./Login/LoginComp";
import { useNavigate } from "react-router-dom";
import urls from "../Utils/urls";

function LandingPage() {
  const navigate = useNavigate();
  const landingPageContent = [
    {
      title: "Support Login",
      description: "Access customer support services and help resources",
      buttonText: "Support Login",
      buttonLink: urls.newBorrowerLogin.pageContent,
    },
    {
      title: "Customer Portal",
      description: "This is the login page for customers only.",
      buttonText: "Customer Login",
      buttonLink: "/login",
    },
  ];

  return (
    <Background>
      <div className="w-75">
        <h3 className="pb-5 mb-3">Welcome to Loanlinq</h3>
        {landingPageContent.map((item, index) => (
          <div
            className="card p-4 shadow-sm p-5"
            style={{ marginBottom: "35px" }}
            key={index}
          >
            <h5 className="card-title mb-3">{item.title}</h5>
            <p className="card-text">{item.description}</p>
            {item.title === "Customer Portal" ? (
              <div
                className={`btn btn-primary w-100`}
                onClick={() => navigate(item.buttonLink)}
              >
                {item.buttonText}
              </div>
            ) : (
              <a className={`btn btn-primary w-100`} href={item.buttonLink}>
                {item.buttonText}
              </a>
            )}
          </div>
        ))}
      </div>
    </Background>
  );
}

export default LandingPage;
